
import XHeader from 'vux/src/components/x-header/index.vue'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'
import Alert from 'vux/src/components/alert/index.vue'

export default {
components:{
XHeader,
Flow,
FlowState,
FlowLine,
Alert
},
data(){
return{
show: false,
message:'',
model:{},
stepTwo:"",
stepThree:"",
stepFourth:0,
className:''   
}
},
created(){
var token = this.getToken() ;
if(token == null || token == ""){
this.$router.replace("/auth/login")
}
this.checkStepOne()
},
methods: {
goBack(){

this.$router.push({
path : '/learn/cooperation',
query : {}
})
},
open(){
if(this.className==''){
this.$router.push('/learn/product/index')
}
},
checkStepOne(){
this.model.token=this.getToken();
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getIsCert',this.model,{emulateJSON:true}).then(function(res){
var cert=(res.body.cert)
this.stepTwo=cert
this.stepThree=cert
if(this.stepThree==2){
this.stepFourth=res.body.checkBuy
}
if(this.stepTwo==3||this.stepThree!=2||this.stepFourth==0){
this.className='noClick'
}
},function(res){
});
},
stepTwoBtn(){
this.$router.push('/user/cert/cert1')
},
stepThreeBtn(){
if(this.stepTwo==3){
this.show=true
this.message="请先提交实名认证资料！"
}else{
this.$router.push('/user/cert/cert1')
}
},
stepFourthBtn(){
if(this.stepTwo==3){
this.show=true
this.message="请先提交实名认证资料！"
}else if(this.stepThree!=2){
this.show=true
this.message="请先完成实名认证！"
}else{
this.$router.push('/learn/buySelect')
}
},

}
}



// WEBPACK FOOTER //
// ./src/views/learn/childcloud.vue